module.exports = __webpack_public_path__ + "static/media/camp-extra-bg.02547aea.png";